var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrowDown4 = function SvgArrowDown4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.663 4.41l3.774 4.588 1.301-1.07-5.101-6.2H6.872l-5.101 6.2 1.3 1.07L6.979 4.25v11.652h1.685V4.41z",
    fill: "#fff",
    fillOpacity: 0.8
  })));
};
export default SvgArrowDown4;